// IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): КАРТИНКИ ВИДЖЕТОВ — состояние, ключи, флаги, транспорт, кэш, команды и автосъёмка.
// Заказ (27.09, дословно): «должна быть команда на Пейдже и на самих виджетах, которая формирует картинку исходя из того, что я вижу сейчас,
// обновляет её в привязке к виджетам, а Page собирается из виджетов; так же сделать визуальное представление виджетов в форме-меню-странички
// по аналогии, тем же переключателем на визуальный вид». Решения Игоря 27.09: картинки видят ВСЕ; снимать без шапки; фоновой пересъёмки нет,
// если картинки ещё нет — снимать автоматически; заменять командой могут ВСЕ пользователи. Дизайн — handoff-files/widget-previews-2026-09-27/DESIGN.md.
//   · ключ картинки — (page, widget, inst): id записи PAGE + id виджета строки страницы + экземпляр тиража (multiply_key, иначе '') — slotOf;
//   · бэк: widget_preview_list / _save / _delete (common_modules/widget_previews.py); бэк без методов отвечает {} — механизм выключается до
//     перезагрузки (команд нет, переключателя вида нет, одна строка в консоли — как recordHelp);
//   · кэш: память (Blob URL) + IndexedDB webscm-previews (флаг fe.ux.widgetPreviewCache), перед list — have {key: at}: приходят только новые;
//   · команды: ≡ виджета «Update preview» (captureOne, manual), кнопка меню страницы «Update page previews» (updatePage, page, повторный клик — стоп);
//   · автосъёмка (раздел 6 дизайна): только ОТСУТСТВУЮЩИЕ картинки активной страницы, в простое пользователя, по одной, лимиты и «медленно — стоп»;
//     под автоматизацией (navigator.webdriver) — только с явным fe.ux.widgetPreviewAutoWebdriver = true;
//   · консоль: window.widgetPreviews = { get(), set(k, v), reset(), stats(), state(), capture(widgetId), remove(page, widget, inst), load(pages, size) }.
import { reactive } from 'vue'
import { t, tn, getLanguage, getLocale } from '@/i18n'
import { previewCapture, previewReady, previewIsEmpty, previewRoot, PREVIEW_SKIP_SEL } from '@/utils/widgetPreview'
import { uiHelp_rows } from '@/utils/uiHelp'

// ---- настройки: флаги (fe.ux.*) и пороги (fe.data.*) — override браузера (feSettings / адрес) → значение базы → умолчание здесь
export const WP_DEFAULTS = {
    'fe.ux.widgetPreviews': true,               // всё: пункт ≡, кнопка меню страницы, переключатель вида меню страницы, картинки в панели страниц
    'fe.ux.widgetPreviewAuto': true,            // автосъёмка отсутствующих картинок
    'fe.ux.widgetPreviewAutoWebdriver': false,  // автосъёмка под автоматизацией (navigator.webdriver) — только для своей пробы
    'fe.ux.widgetPreviewAutoSkipEmpty': true,   // автоматически пустые виджеты не снимаются
    'fe.ux.widgetPreviewCache': true,           // IndexedDB + have (оптимизация)
    'fe.ux.widgetPreviewPruneHidden': true,     // отсекать скрытые поддеревья при клонировании (оптимизация; A/B — в пробе)
    'fe.data.widgetPreviewLong': 480,
    'fe.data.widgetPreviewThumb': 240,
    'fe.data.widgetPreviewQuality': 0.8,
    'fe.data.widgetPreviewAutoIdleMs': 5000,
    'fe.data.widgetPreviewAutoGapMs': 8000,
    'fe.data.widgetPreviewPageDwellMs': 10000,
    'fe.data.widgetPreviewAutoSettleMs': 5000,
    'fe.data.widgetPreviewAutoQuietMs': 2000,
    'fe.data.widgetPreviewAutoPerPage': 3,
    'fe.data.widgetPreviewAutoPerSession': 12,
    'fe.data.widgetPreviewAutoSlowMs': 4500,
    'fe.data.widgetPreviewStalePct': 20,
    'fe.data.widgetPreviewListTtlSec': 60,
    'fe.data.widgetPreviewCacheMax': 800,
}
const SYSTEM_WIDGETS = ['widget-row', 'widget-record', 'widget-raw-record', 'widget-page-widgets']
const CALL_TIMEOUT_MS = 30000
const TICK_MS = 2000

export const wpState = reactive({ epoch: 0, supported: null, busy: false, pageRun: null })
const mem = { thumb: new Map(), full: new Map(), meta: new Map() }   // key → pic; реактивность — через wpState.epoch
const stats = { captures: [], lists: [], saves: 0, saveErrors: 0, autoSkips: {}, autoWhy: {}, autoSaves: 0, unsupported: 0 }
let _store = null
let _chain = Promise.resolve()   // снимки — строго по одному
let _warned = false

// ---------------------------------------------------------------- настройки
export function wp_setting(store, key) {
    const def = WP_DEFAULTS[key]
    try { const s = store || _store; return s && typeof s.setting === 'function' ? s.setting(key, def) : def } catch (e) { return def }
}
const num = (store, key) => { const v = Number(wp_setting(store, key)); return Number.isFinite(v) ? v : WP_DEFAULTS[key] }
const mobileOn = (store) => !!(store && store.mobileUi && store.mobileUi.on)
// механизм включён (настройка, не мобильный профиль, бэк не отказал)
export function widgetPreviews_on(store) {
    void (store && store._settingsEpoch)
    if (!store || mobileOn(store)) return false
    return wp_setting(store, 'fe.ux.widgetPreviews') !== false && wpState.supported !== false
}
// бэк подтвердил методы (первый ответ list) — команды и переключатель вида показываются только тогда
// IE 2026 09 29 / ODOO-342781: роль «только чтение» — снимки пишутся в общую таблицу (бэк отказывает widget_preview_save/delete), поэтому команды и автоснимок выключены; чтение картинок остаётся
const roOn = (store) => { try { return !!(store && store.readonly_on && store.readonly_on()) } catch (e) { return false } }
export function widgetPreviews_ready(store) { return widgetPreviews_on(store) && wpState.supported === true && !roOn(store) }
export function widgetPreviews_autoOn(store) {
    if (!widgetPreviews_on(store) || roOn(store) || wp_setting(store, 'fe.ux.widgetPreviewAuto') === false) return false
    let wd = false
    try { wd = typeof navigator !== 'undefined' && navigator.webdriver === true } catch (e) { wd = false }
    return !wd || wp_setting(store, 'fe.ux.widgetPreviewAutoWebdriver') === true
}

// ---------------------------------------------------------------- ключи и строки страницы
export const wpKey = (page, widget, inst = '') => `${page}|${widget}|${inst || ''}`
function fnv(s) { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0 } return h.toString(36) }
// экземпляр тиража: multiply_key (≤ 200 знаков — как есть, длиннее — отпечаток; бэк принимает inst ≤ 200)
export const wpInstOf = (mk) => { const s = String(mk || ''); return s.length <= 200 ? s : '#' + fnv(s) + '-' + fnv(s.split('').reverse().join('')) }
const pct = (v) => { if (v === null || v === undefined || v === '') return null; const n = Number(v); return Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : null }
// раскладка строки страницы: только то, что сравнивает «устаревание» (free / width / height / left / top, % 0…100 либо null)
export function wpLayOf(row) {
    const l = (row && row.layout) || {}
    return { free: !!l.free, width: pct(l.width), height: pct(l.height), left: pct(l.left), top: pct(l.top) }
}
export const wpRowWidget = (r) => (r && (r.widget || (r.node && r.node.relation_segment ? r.node.value : null))) || null

// слот виджета: строка страницы с этим виджетом → { page, widget, inst, key, row, lay }; нет строки (окна widget-row / widget-record, виджет, открытый мимо
// раскладки, временная страница '1') — null: такому виджету ни команда, ни автосъёмка не положены
export function widgetPreviews_slotOf(store, W) {
    if (!store || !W || !W.page || String(W.page) === '1' || SYSTEM_WIDGETS.includes(W.widget)) return null
    const WS = store.WORKSPACES && store.WORKSPACES[W.workspace]
    const P = WS && WS.PAGES && WS.PAGES[W.page]
    if (!P) return null
    let found = null
    const walk = (rows) => {
        for (const r of rows || []) {
            if (found) return
            if (!r || r.use === false) continue
            const id = wpRowWidget(r)
            if (id) {
                if (r.multiply && r.multiply.widget) {
                    if (W._multiply && W._multiply.key && typeof store.multiply_key === 'function' && W._multiply.key === store.multiply_key(W.page, id, r.multiply)) { found = { row: r, widget: String(id), inst: wpInstOf(W.multiply_key) }; return }
                } else if (!W.multiply_key && (String(id) === String(W.widget) || (W.record && W.record.id && String(id) === String(W.record.id)))) { found = { row: r, widget: String(id), inst: '' }; return }
            }
            if (r.attrs) walk(r.attrs)
        }
    }
    walk(P.attrs)
    if (!found) return null
    return { page: String(W.page), widget: found.widget, inst: found.inst, key: wpKey(W.page, found.widget, found.inst), row: found.row, lay: wpLayOf(found.row) }
}

// «размер на странице изменился»: сменился free либо ширина / высота строки отличается от снятой больше чем на pct % (от max(старое, 1));
// нет размеров — как у раскладки (закреплённый 50 × 50, свободный 40 × 30). Сравнивается раскладка строки, а не пиксели экрана
export function widgetPreviews_staleSize(picLay, rowLay, stalePct = 20) {
    if (!picLay || !rowLay) return false
    const f0 = !!picLay.free, f1 = !!rowLay.free
    if (f0 !== f1) return true
    const dw = f1 ? 40 : 50, dh = f1 ? 30 : 50
    const diff = (a, b, d) => { const x = (a === null || a === undefined) ? d : Number(a), y = (b === null || b === undefined) ? d : Number(b); return Math.abs(y - x) / Math.max(x, 1) * 100 > stalePct }
    return diff(picLay.width, rowLay.width, dw) || diff(picLay.height, rowLay.height, dh)
}

// чипсы стола словами (для подсказки «Chips at capture»): строки WHERE записи стола — use ≠ false, без calc* и скрытых; title строки, иначе «поле: значения»
export function widgetPreviews_chipsText(WS, max = 600) {
    const rows = (WS && WS.record && WS.record.doc && WS.record.doc.params && WS.record.doc.params.WHERE) || []
    const out = []
    const str = (v) => (v === null || v === undefined) ? '' : String(typeof v === 'object' ? (v.valueStr ?? v.title ?? v.value ?? '') : v)
    for (const r of rows) {
        if (!r || r.use === false || r.hidden) continue
        const lv = r.leftValue || {}
        const field = String(lv.value || '')
        if (!field || field.startsWith('calc')) continue
        let text = String(r.title || '').trim()
        if (!text) {
            const vals = (r.attrs || []).filter(a => a && a.use !== false).map(a => str(a.rightValue && (a.rightValue.valueStr || a.rightValue.value))).filter(Boolean)
            const v = vals.length ? vals.slice(0, 5).join(', ') + (vals.length > 5 ? ', …' : '') : str(r.rightValue && (r.rightValue.valueStr || r.rightValue.value))
            if (!v) continue
            text = `${str(lv.valueStr || lv.value)}: ${v}`
        }
        out.push(text)
    }
    let s = ''
    for (const ch of out.join(' · ')) { const c = ch.charCodeAt(0); s += (c < 32 || c === 127) ? ' ' : ch }   // управляющие символы → пробел (как бэк)
    return s.length > max ? s.slice(0, max - 1) + '…' : s
}

// ---------------------------------------------------------------- кэш в памяти
const picOf = (row, url, size) => ({
    key: row.key, page: row.page, widget: row.widget, inst: row.inst || '', url, size, at: row.at, by: row.by || '', mode: row.mode || '', kind: row.kind || 'other',
    mime: row.mime, w: row.w, h: row.h, src_w: row.src_w, src_h: row.src_h, lay: row.lay || null, tab: row.tab || '', chips_text: row.chips_text || '',
    rec_id: row.rec_id || '', rec_segment: row.rec_segment || '', stale_record: row.stale_record ?? false, rec_saved_at: row.rec_saved_at || '',
    rec_saved_by: row.rec_saved_by || '', created_by: row.created_by || '', created_at: row.created_at || '', lang: row.lang || '', fe: row.fe || '', ms: row.ms ?? null, bytes: row.bytes ?? null,
})
function memPut(size, row, blob) {
    const m = mem[size]
    const old = m.get(row.key)
    if (old && old.url && old.at === row.at && !blob) { m.set(row.key, { ...picOf(row, old.url, size), blob: old.blob }); return }
    if (old && old.url) { try { URL.revokeObjectURL(old.url) } catch (e) { /* уже */ } }
    const url = blob ? URL.createObjectURL(blob) : ''
    m.set(row.key, { ...picOf(row, url, size), blob: blob || null })
}
function memDrop(size, key) {
    const old = mem[size].get(key)
    if (old && old.url) { try { URL.revokeObjectURL(old.url) } catch (e) { /* уже */ } }
    mem[size].delete(key)
}
// картинка ключа: нужного размера, иначе другого (full ↔ thumb); null — нет
export function widgetPreviews_pic(page, widget, inst = '', size = 'thumb') {
    void wpState.epoch
    const k = wpKey(page, widget, inst)
    const a = mem[size === 'full' ? 'full' : 'thumb'].get(k), b = mem[size === 'full' ? 'thumb' : 'full'].get(k)
    const p = (a && a.url) ? a : ((b && b.url) ? b : null)
    return p
}
// картинка строки страницы: у тиража — самая свежая из экземпляров (и строки без экземпляра)
export function widgetPreviews_picOfRow(page, row, size = 'thumb') {
    void wpState.epoch
    const id = wpRowWidget(row)
    if (!page || !id) return null
    if (!(row && row.multiply && row.multiply.widget)) return widgetPreviews_pic(page, id, '', size)
    const pre = `${page}|${id}|`
    let best = null
    for (const m of [mem[size === 'full' ? 'full' : 'thumb'], mem[size === 'full' ? 'thumb' : 'full']]) {
        for (const [k, p] of m) if (k.startsWith(pre) && p.url && (!best || String(p.at) > String(best.at))) best = p
        if (best) break
    }
    return best
}
// есть ли на сервере картинка ключа (по мете последнего list); undefined — неизвестно
export const widgetPreviews_known = (key) => mem.meta.has(key) ? true : undefined

// ---------------------------------------------------------------- IndexedDB (webscm-previews / pics): ключ <dbid>|<size>|<page>|<widget>|<inst>
const IDB_NAME = 'webscm-previews', IDB_STORE = 'pics'
let _idbP = null
function _idb() {
    if (_idbP) return _idbP
    _idbP = new Promise((resolve) => {
        try {
            if (typeof indexedDB === 'undefined') return resolve(null)
            const req = indexedDB.open(IDB_NAME, 1)
            req.onupgradeneeded = () => { try { req.result.createObjectStore(IDB_STORE) } catch (e) { /* уже есть */ } }
            req.onsuccess = () => resolve(req.result)
            req.onerror = () => resolve(null)
            req.onblocked = () => resolve(null)
        } catch (e) { resolve(null) }
    })
    return _idbP
}
const cacheOn = (store) => wp_setting(store, 'fe.ux.widgetPreviewCache') !== false
const dbidOf = (store) => String((store && store.user && store.user.database && store.user.database.dbid) || '')
// записи кэша размера size для набора страниц — ОДНИМ курсором по префиксу <dbid>|<size>| (потолок кэша — сотни записей; по курсору на страницу
// панель страниц на 30 страниц ждала бы 30 транзакций подряд, пока главный поток рисует карточки)
async function idbRange(store, size, pages) {
    const db = await _idb()
    if (!db) return []
    const pre = `${dbidOf(store)}|${size}|`
    const want = new Set(pages)
    return new Promise((resolve) => {
        const out = []
        try {
            const rq = db.transaction(IDB_STORE, 'readonly').objectStore(IDB_STORE).openCursor(IDBKeyRange.bound(pre, pre + '\uffff'))
            rq.onsuccess = () => {
                const c = rq.result
                if (!c) { resolve(out); return }
                const key = String(c.key).slice(pre.length)
                if (want.has(key.split('|')[0])) out.push({ key, idbKey: c.key, v: c.value })
                c.continue()
            }
            rq.onerror = () => resolve(out)
        } catch (e) { resolve(out) }
    })
}
async function idbPut(store, size, key, value) {
    const db = await _idb()
    if (!db) return false
    return new Promise((resolve) => {
        try { const tx = db.transaction(IDB_STORE, 'readwrite'); tx.objectStore(IDB_STORE).put({ ...value, used: Date.now() }, `${dbidOf(store)}|${size}|${key}`); tx.oncomplete = () => resolve(true); tx.onerror = () => resolve(false) } catch (e) { resolve(false) }
    })
}
async function idbDelete(idbKey) {
    const db = await _idb()
    if (!db) return false
    return new Promise((resolve) => { try { const tx = db.transaction(IDB_STORE, 'readwrite'); tx.objectStore(IDB_STORE).delete(idbKey); tx.oncomplete = () => resolve(true); tx.onerror = () => resolve(false) } catch (e) { resolve(false) } })
}
// потолок записей кэша: вытесняются давно не использованные
async function idbPrune(store) {
    const db = await _idb()
    if (!db) return
    const max = num(store, 'fe.data.widgetPreviewCacheMax')
    try {
        const all = await new Promise((resolve) => {
            const out = []
            const rq = db.transaction(IDB_STORE, 'readonly').objectStore(IDB_STORE).openCursor()
            rq.onsuccess = () => { const c = rq.result; if (c) { out.push({ k: c.key, used: (c.value && c.value.used) || 0 }); c.continue() } else resolve(out) }
            rq.onerror = () => resolve(out)
        })
        if (all.length <= max) return
        all.sort((a, b) => a.used - b.used)
        for (const x of all.slice(0, all.length - max)) await idbDelete(x.k)
    } catch (e) { /* кэш — не обязателен */ }
}

// ---------------------------------------------------------------- транспорт
function _noMethod() {
    stats.unsupported++
    wpState.supported = false
    wpState.epoch++
    if (!_warned) { _warned = true; try { console.info('widgetPreviews: the backend has no widget_preview_* methods — widget previews are off until the page is reloaded') } catch (e) { /* без консоли */ } }
}
function _call(store, method, params, ms = CALL_TIMEOUT_MS) {
    return new Promise((resolve) => {
        let done = false
        const fin = (v) => { if (!done) { done = true; clearTimeout(tm); resolve(v) } }
        const tm = setTimeout(() => fin({ ok: false, error: 'no answer from the server' }), ms)
        try {
            store.executeBackendMethod({}, { method, params }, (answer) => {
                if (!answer || typeof answer !== 'object') { fin({ ok: false, error: 'empty answer' }); return }
                if (!Array.isArray(answer.widget_previews) && !answer.status) {
                    const note = answer.notification
                    if (note && ['error', 'critical'].includes(note.status)) { fin({ ok: false, error: String(note.text || 'error') }); return }
                    _noMethod(); fin({ ok: false, error: 'no-method', noMethod: true }); return
                }
                if (wpState.supported !== true) { wpState.supported = true; wpState.epoch++ }
                if (answer.status === 'error') { fin({ ok: false, error: String(answer.message || 'error'), answer }); return }
                fin({ ok: true, answer })
            })
        } catch (e) { fin({ ok: false, error: String((e && e.message) || e) }) }
    })
}
function b64ToBlob(b64, mime) {
    const bin = atob(b64)
    const u = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i)
    return new Blob([u], { type: mime || 'application/octet-stream' })
}
function blobToB64(blob) {
    return new Promise((resolve, reject) => {
        const fr = new FileReader()
        fr.onload = () => { const s = String(fr.result || ''); resolve(s.slice(s.indexOf(',') + 1)) }
        fr.onerror = () => reject(fr.error || new Error('read failed'))
        fr.readAsDataURL(blob)
    })
}

// ---------------------------------------------------------------- загрузка картинок страниц
const _lists = new Map()   // `${dbid}|${size}|${pages}` → { at, p }
// pages — id записей PAGE; size — thumb | full | meta; повтор не чаще fe.data.widgetPreviewListTtlSec на тот же набор (opts.force — всегда)
export function widgetPreviews_load(store, pages, size = 'thumb', opts = {}) {
    store = store || _store
    if (!widgetPreviews_on(store)) return Promise.resolve(null)
    const list = [...new Set((pages || []).filter(Boolean).map(String))].sort().slice(0, 300)
    if (!list.length) return Promise.resolve(null)
    const lk = `${dbidOf(store)}|${size}|${list.join(',')}`
    const ttl = num(store, 'fe.data.widgetPreviewListTtlSec') * 1000
    const prev = _lists.get(lk)
    if (prev && !opts.force && (prev.pending || Date.now() - prev.at < ttl)) return prev.p
    const p = _load(store, list, size).finally(() => { const e = _lists.get(lk); if (e) { e.pending = false; e.at = Date.now() } })
    _lists.set(lk, { at: Date.now(), p, pending: true })
    return p
}
async function _load(store, pages, size) {
    const t0 = performance.now()
    const useCache = cacheOn(store) && size !== 'meta'
    const have = {}
    const cached = new Map()
    if (size !== 'meta') {
        for (const [k, p] of mem[size]) if (pages.includes(p.page) && p.url) have[k] = p.at
        if (useCache) {
            for (const e of await idbRange(store, size, pages)) { if (e.v && e.v.at) { cached.set(e.key, e); if (!have[e.key]) have[e.key] = e.v.at } }
        }
    }
    const seen = new Set()
    let rows = 0, withData = 0, bytes = 0, fromCache = 0, calls = 0, omitted = 0, table = null
    for (let pass = 0; pass < 5; pass++) {
        calls++
        const r = await _call(store, 'widget_preview_list', { pages, size, have, max_bytes: 3000000 })
        if (!r.ok) { stats.lists.push({ pages: pages.length, size, ms: Math.round(performance.now() - t0), error: r.error }); trimStats(); return null }
        const ans = r.answer
        table = ans.table
        omitted = +ans.omitted || 0
        for (const row of ans.widget_previews || []) {
            if (!row || !row.key) continue
            if (!seen.has(row.key)) rows++
            seen.add(row.key)
            mem.meta.set(row.key, { ...row, data: undefined })
            if (size === 'meta') continue
            if (row.data) {
                const blob = b64ToBlob(row.data, row.mime)
                withData++; bytes += blob.size
                memPut(size, row, blob)
                have[row.key] = row.at
                if (useCache) idbPut(store, size, row.key, { at: row.at, mime: row.mime, blob, w: row.w, h: row.h, meta: { ...row, data: undefined } })
            } else if (have[row.key] === row.at) {
                const cur = mem[size].get(row.key)
                if (cur && cur.url && cur.at === row.at) memPut(size, row, null)   // та же версия в памяти — обновить мету (устаревание)
                else { const e = cached.get(row.key); if (e && e.v && e.v.blob) { memPut(size, row, e.v.blob); fromCache++; if (useCache) idbPut(store, size, row.key, { ...e.v }) } }
            }
        }
        if (!omitted) break
    }
    // ключи, которых нет в ответе, — картинки удалены: из памяти и кэша
    for (const m of [mem.thumb, mem.full, mem.meta]) for (const k of [...m.keys()]) { const pg = k.split('|')[0]; if (pages.includes(pg) && !seen.has(k)) { if (m === mem.meta) m.delete(k); else memDrop(m === mem.full ? 'full' : 'thumb', k) } }
    if (useCache) { for (const [k, e] of cached) if (!seen.has(k)) idbDelete(e.idbKey); idbPrune(store) }
    wpState.epoch++
    stats.lists.push({ pages: pages.length, size, ms: Math.round(performance.now() - t0), rows, withData, bytes, fromCache, calls, omitted, table })
    trimStats()
    return { rows, withData, bytes, fromCache, table }
}
function trimStats() {
    if (stats.captures.length > 50) stats.captures.splice(0, stats.captures.length - 50)
    if (stats.lists.length > 50) stats.lists.splice(0, stats.lists.length - 50)
}

// ---------------------------------------------------------------- снимок и сохранение
const sleep = (ms) => new Promise(r => setTimeout(r, ms))
const frames = (n = 2) => new Promise(r => { const step = (k) => (k <= 0 ? r() : requestAnimationFrame(() => step(k - 1))); step(n) })
const feVersion = () => { try { return String((document.querySelector('meta[name="fe-config-version"]') || {}).content || process.env.VUE_APP_CONFIG_VERSION || '').slice(0, 40) } catch (e) { return '' } }
const titleOf = (W) => String((W && (W.title || (W.record && W.record.title) || W.widget)) || '')
export function widgetPreviews_whyText(why) {
    switch (why) {
        case 'loading': return t('the widget is still loading')
        case 'hidden': return t('the widget is not visible')
        case 'closed': return t('the widget is closed')
        case 'too-small': return t('the widget is too small')
        case 'maximized': return t('the widget is expanded to the full page')
        case 'no-dom': case 'no-widget': return t('the widget is not on the screen')
        case 'no-slot': return t('the widget is not in the layout of this page')
        case 'unsupported': return t('widget previews are not available on this server')
        case 'capture-failed': return t('the picture could not be drawn')
        case 'busy': return t('another preview is being taken')
        default: return String(why || '')
    }
}
function toast(store, text, status) { try { store.show_notification({ text, status, visible: true }) } catch (e) { /* без тостов */ } }

// один снимок + сохранение. opts: mode (manual | page | auto), toast (тосты хода / итога), allowMax
export function widgetPreviews_captureOne(store, W, opts = {}) {
    const run = () => _captureOne(store || _store, W, opts)
    const p = _chain.then(run, run)
    _chain = p.catch(() => null)
    return p
}
async function _captureOne(store, W, opts) {
    const mode = opts.mode || 'manual'
    const loud = opts.toast !== false && mode !== 'auto'
    const title = titleOf(W)
    if (mode !== 'auto') auto.cancel()   // ручная команда и команда страницы вытесняют очередь автосъёмки
    if (!widgetPreviews_ready(store)) { if (loud) toast(store, t('The preview could not be taken: {reason}', { reason: widgetPreviews_whyText('unsupported') }), 'error'); return { ok: false, why: 'unsupported' } }
    const slot = widgetPreviews_slotOf(store, W)
    if (!slot) { if (loud) toast(store, t('The preview could not be taken: {reason}', { reason: widgetPreviews_whyText('no-slot') }), 'error'); return { ok: false, why: 'no-slot' } }
    wpState.busy = true
    try {
        if (loud) { toast(store, t('Taking the preview of «{title}»…', { title }), 'pending'); await frames(2); await sleep(150) } else if (mode === 'page') await frames(1)
        const res = await previewCapture(W, { mode, long: num(store, 'fe.data.widgetPreviewLong'), thumb: num(store, 'fe.data.widgetPreviewThumb'),
            quality: num(store, 'fe.data.widgetPreviewQuality'), pruneHidden: wp_setting(store, 'fe.ux.widgetPreviewPruneHidden') !== false })
        const st = { t: Date.now(), widget: slot.widget, inst: slot.inst, kind: res.kind || '', mode, ms: res.ms, lt: res.lt, bytes: res.bytes || 0, tbytes: res.tbytes || 0,
            nodes: res.nodes || 0, pruned: res.pruned || 0, blank: !!res.blank, ok: false, why: res.ok ? '' : res.why, w: res.w, h: res.h }
        stats.captures.push(st); trimStats()
        if (!res.ok) { if (loud) toast(store, t('The preview could not be taken: {reason}', { reason: widgetPreviews_whyText(res.why) }), 'error'); return { ...st, ok: false } }
        if (res.blank) { st.why = 'blank'; if (loud) { try { store.close_notification() } catch (e) { /* без тоста */ } toast(store, t('The preview came out empty and was not saved'), 'warning') } return { ...st, ok: false } }
        const WS = store.WORKSPACES && store.WORKSPACES[W.workspace]
        const item = { page: slot.page, widget: slot.widget, inst: slot.inst, mode, mime: res.mime, data: await blobToB64(res.blob), w: res.w, h: res.h,
            src_w: res.src_w, src_h: res.src_h, lay: slot.lay, tab: String(store.widget_activeTab ? store.widget_activeTab(W) || '' : '').slice(0, 120), kind: res.kind,
            chips_text: widgetPreviews_chipsText(WS), rec_id: String((W.record && W.record.id) || slot.widget), rec_segment: String((W.record && W.record.segment) || ''),
            lang: String(getLanguage() || '').slice(0, 8), fe: feVersion(), ms: res.ms }
        if (!res.thumbSame) Object.assign(item, { thumb_mime: res.tmime, thumb: await blobToB64(res.tblob), tw: res.tw, th: res.th })
        const r = await _call(store, 'widget_preview_save', { items: [item] })
        const saved = r.ok && r.answer && Array.isArray(r.answer.saved) ? r.answer.saved[0] : null
        if (!saved) {
            stats.saveErrors++
            const why = (r.answer && r.answer.errors && r.answer.errors[0] && r.answer.errors[0].message) || r.error || 'error'
            st.why = 'save: ' + why
            if (loud) toast(store, t('The preview could not be saved: {reason}', { reason: why }), 'error')
            return { ...st, ok: false }
        }
        stats.saves++
        st.ok = true; st.result = saved.result
        const row = { key: slot.key, page: slot.page, widget: slot.widget, inst: slot.inst, at: saved.at, by: saved.by, mode: saved.mode || mode, kind: res.kind,
            src_w: res.src_w, src_h: res.src_h, lay: slot.lay, tab: item.tab, chips_text: item.chips_text, rec_id: item.rec_id, rec_segment: item.rec_segment,
            stale_record: false, created_by: saved.by, lang: item.lang, fe: item.fe, ms: res.ms, bytes: res.bytes + (res.thumbSame ? 0 : res.tbytes) }
        if (saved.result === 'kept') {
            mem.meta.set(slot.key, { ...row, at: saved.at, by: saved.by })   // автоснимок: картинку успел сохранить другой — она есть, не трогаем
        } else {
            mem.meta.set(slot.key, row)
            memPut('full', { ...row, mime: res.mime, w: res.w, h: res.h }, res.blob)
            memPut('thumb', { ...row, mime: res.thumbSame ? res.mime : res.tmime, w: res.tw, h: res.th }, res.thumbSame ? res.blob : res.tblob)
            if (cacheOn(store)) {
                idbPut(store, 'full', slot.key, { at: saved.at, mime: res.mime, blob: res.blob, w: res.w, h: res.h, meta: row })
                idbPut(store, 'thumb', slot.key, { at: saved.at, mime: res.thumbSame ? res.mime : res.tmime, blob: res.thumbSame ? res.blob : res.tblob, w: res.tw, h: res.th, meta: row })
            }
            wpState.epoch++
        }
        if (loud) { try { store.close_notification() } catch (e) { /* без тоста */ } toast(store, t('Preview of «{title}» updated', { title }), 'success') }
        return { ...st }
    } catch (e) {
        if (loud) toast(store, t('The preview could not be taken: {reason}', { reason: String((e && e.message) || e) }), 'error')
        return { ok: false, why: 'exception', error: String((e && e.message) || e) }
    } finally {
        wpState.busy = false
    }
}

// открытые виджеты активной страницы со слотом (экземпляры тиража — каждый)
function pageWidgets(store) {
    const WS = store && store.activeWORKSPACE
    const pg = WS && WS.active_page
    if (!pg) return []
    return (WS.ALL_WIDGETS || []).filter(w => w && String(w.page) === String(pg) && !w.close && !w._softClosed && !w._hiddenOpen && widgetPreviews_slotOf(store, w))
}
// «Update page previews»: открытые виджеты страницы по очереди (300 мс между снимками), ход в липком тосте; повторный вызов — стоп после текущего снимка
export async function widgetPreviews_updatePage(store) {
    store = store || _store
    if (wpState.pageRun) { wpState.pageRun.stop = true; return { stopping: true } }
    if (!widgetPreviews_ready(store)) { toast(store, t('The preview could not be taken: {reason}', { reason: widgetPreviews_whyText('unsupported') }), 'error'); return { ok: false } }
    const WS = store.activeWORKSPACE
    const pg = WS && WS.active_page
    const list = pageWidgets(store)
    const openIds = (typeof store.page_openSet === 'function' && WS) ? (store.page_openSet(WS.workspace, pg).ids || []).map(String) : []
    const openNow = new Set(list.map(w => widgetPreviews_slotOf(store, w).widget))
    const notOpen = openIds.filter(id => !openNow.has(id)).length
    const run = reactive({ i: 0, n: list.length, stop: false, ok: 0, failed: 0 })
    wpState.pageRun = run
    auto.cancel()
    try {
        for (const W of list) {
            if (run.stop) break
            run.i++
            toast(store, t('Updating page previews: {i} of {n}…', { i: run.i, n: run.n }), 'pending')
            // виджет ещё грузится (страницу только что открыли / перечитали) — подождать его, не дольше 20 с (стоп прерывает ожидание)
            for (let k = 0; k < 66 && !run.stop; k++) { const rd = previewReady(W, { allowMax: true }); if (rd.ok || rd.why !== 'loading') break; await sleep(300) }
            if (run.stop) break
            const r = await widgetPreviews_captureOne(store, W, { mode: 'page', toast: false })
            if (r && r.ok) run.ok++; else run.failed++
            await sleep(300)
        }
    } finally {
        wpState.pageRun = null
    }
    const parts = [tn(run.ok, '{n} preview updated', '{n} previews updated')]
    if (run.failed) parts.push(tn(run.failed, '{n} preview could not be taken', '{n} previews could not be taken'))
    if (notOpen) parts.push(tn(notOpen, '{n} widget is not open — its preview was not updated', '{n} widgets are not open — their previews were not updated'))
    if (run.stop) parts.push(t('Stopped'))
    try { store.close_notification() } catch (e) { /* без тоста */ }
    toast(store, parts.join(' · '), run.failed && !run.ok ? 'error' : 'success')
    return { ok: run.ok, failed: run.failed, notOpen, stopped: run.stop, n: run.n }
}

// ---------------------------------------------------------------- подсказки
export function wp_fmtAt(at) {
    if (!at) return ''
    try { return new Date(at).toLocaleString(getLocale(), { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) } catch (e) { return String(at) }
}
// причина устаревания картинки: запись виджета сохранена позже с другим doc / записи нет / размер строки на странице изменился; '' — актуальна
export function widgetPreviews_staleWhy(store, pic, rowLay) {
    if (!pic) return ''
    if (pic.stale_record === 'gone') return t('The widget record no longer exists')
    if (pic.stale_record === true) return t('The widget settings were saved after the preview was taken ({date}, {user})', { date: wp_fmtAt(pic.rec_saved_at), user: pic.rec_saved_by || '—' })
    if (rowLay && widgetPreviews_staleSize(pic.lay, rowLay, num(store, 'fe.data.widgetPreviewStalePct'))) return t('The widget size on the page changed after the preview was taken')
    return ''
}
export function widgetPreviews_capturedText(pic) {
    if (!pic) return ''
    const how = pic.mode === 'auto' ? t('automatically') : (pic.mode === 'page' ? t('by the page command') : t('by the widget command'))
    return t('Captured {date} by {user} ({how})', { date: wp_fmtAt(pic.at), user: pic.by || '—', how })
}
// строки Alt-подсказки пункта ≡ «Update preview»: объяснение (uiHelp widget.menu.previewUpdate) + текущая картинка (когда, кем, чипсы, вкладка, устаревание)
export function widgetPreviews_menuTipRows(store, W) {
    const out = {}
    try { Object.assign(out, uiHelp_rows('widget.menu.previewUpdate')) } catch (e) { /* без объяснений */ }
    const slot = widgetPreviews_slotOf(store, W)
    if (!slot) return out
    const pic = widgetPreviews_pic(slot.page, slot.widget, slot.inst, 'full') || null
    const meta = pic || mem.meta.get(slot.key) || null
    if (!meta) { out[t('Preview')] = t('Not taken yet'); return out }
    out[t('Preview')] = widgetPreviews_capturedText(meta)
    if (meta.chips_text) out[t('Chips at capture')] = meta.chips_text
    if (meta.tab) out[t('Tab at capture')] = meta.tab
    const why = widgetPreviews_staleWhy(store, meta, slot.lay)
    if (why) out[t('Outdated')] = why
    return out
}
// пункт ≡ «Update preview» виден: механизм подтверждён бэком, у виджета есть слот на странице (getter visible пункта — реактивно)
export function widgetPreviews_menuVisible(store, W) { void wpState.epoch; return widgetPreviews_ready(store) && !!widgetPreviews_slotOf(store, W) }

// ---------------------------------------------------------------- автосъёмка (раздел 6 дизайна)
// решение по одному виджету — чистая функция (юнит-тест): s — снимок состояния, → { ok, why }
export function widgetPreviews_autoEligible(s) {
    if (!s.autoOn) return { ok: false, why: 'off' }
    if (!s.visibleTab) return { ok: false, why: 'tab-hidden' }
    if (s.busy) return { ok: false, why: 'busy' }
    if (s.sessionSlow >= 2) return { ok: false, why: 'session-slow' }
    if (s.perSession >= s.cfg.perSession) return { ok: false, why: 'session-limit' }
    if (s.pageSlow) return { ok: false, why: 'page-slow' }
    if (s.perPage >= s.cfg.perPage) return { ok: false, why: 'page-limit' }
    if (s.now - s.pageSince < s.cfg.dwell) return { ok: false, why: 'page-dwell' }
    if (s.now - s.lastInput < s.cfg.idle) return { ok: false, why: 'user-busy' }
    if (s.uiBusy) return { ok: false, why: 'ui-busy' }
    if (s.now - s.lastAuto < s.cfg.gap) return { ok: false, why: 'gap' }
    if (!s.metaLoaded) return { ok: false, why: 'list-pending' }
    const w = s.w
    if (!w) return { ok: false, why: 'no-candidate' }
    if (w.known) return { ok: false, why: 'has-picture' }
    if (w.tried) return { ok: false, why: 'tried' }
    if (!w.ready) return { ok: false, why: w.readyWhy || 'not-ready' }
    if (!w.loadedAt || s.now - w.loadedAt < s.cfg.settle) return { ok: false, why: 'settling' }
    if (s.now - w.quietSince < s.cfg.quiet) return { ok: false, why: 'dom-busy' }
    if (w.modified) return { ok: false, why: 'modified' }
    if (!w.tabOk) return { ok: false, why: 'other-tab' }
    if (w.scrolled) return { ok: false, why: 'scrolled' }
    if (w.maximized) return { ok: false, why: 'maximized' }
    if (s.cfg.skipEmpty && w.empty) return { ok: false, why: 'empty' }
    return { ok: true, why: '' }
}
const auto = {
    started: false, timer: 0, lastInput: 0, lastMove: 0, lastAuto: 0, perSession: 0, sessionSlow: 0,
    page: { key: '', since: 0, n: 0, slow: false, metaAt: 0, metaOk: false }, tried: new Set(), loadedAt: new Map(), firstTab: new Map(),
    obs: new Map(), idle: 0, cancelled: 0,
    cancel() { if (this.idle) { try { (window.cancelIdleCallback || clearTimeout)(this.idle) } catch (e) { /* уже */ } this.idle = 0; this.cancelled++ } },
}
const skip = (why, key) => { stats.autoSkips[why] = (stats.autoSkips[why] || 0) + 1; if (key) stats.autoWhy[key] = why }
function uiBusy(store) {
    try {
        if (document.querySelector('.menu-panel:not(.menu-panel-inline)')) return true
        if (store.dropdown && store.dropdown.visible) return true
        if (document.fullscreenElement) return true
        const ae = document.activeElement
        if (ae && (ae.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName))) return true
        if (_altHeld) return true
    } catch (e) { return false }
    return false
}
let _altHeld = false
// DOM «тихий»: наблюдатель на содержимом виджета; изменения внутри всплывающего / служебного (плеер Flow Map тикает постоянно) не считаются
function quietSince(W, el) {
    let o = auto.obs.get(W.id)
    if (o && o.el !== el) { try { o.mo.disconnect() } catch (e) { /* уже */ } o = null }
    if (!o) {
        o = { el, since: Date.now(), mo: null }
        try {
            o.mo = new MutationObserver((recs) => {
                for (const r of recs) {
                    const n = r.target && (r.target.nodeType === 1 ? r.target : r.target.parentElement)
                    if (n && n.closest && n.closest(PREVIEW_SKIP_SEL)) continue
                    // скрытые поддеревья (фоновый домонтаж скрытых вкладок — lazyTabs) картинку не меняют
                    try { if (n && (!n.isConnected || n.getClientRects().length === 0)) continue } catch (e) { /* узел исчез */ }
                    o.since = Date.now(); break
                }
            })
            o.mo.observe(el, { subtree: true, childList: true, attributes: true, characterData: true })
        } catch (e) { /* без наблюдателя — считаем тихим с момента создания */ }
        auto.obs.set(W.id, o)
    }
    return o.since
}
function dropObservers(keep) { for (const [id, o] of auto.obs) if (!keep.has(id)) { try { o.mo && o.mo.disconnect() } catch (e) { /* уже */ } auto.obs.delete(id) } }
function scrolled(el) {
    for (const g of el.querySelectorAll('.wj-flexgrid')) {
        if (!g.getClientRects().length) continue
        const root = g.querySelector('[wj-part="root"]')
        if (root && (root.scrollTop > 2 || root.scrollLeft > 2)) return true
    }
    return false
}
function autoCfg(store) {
    return { idle: num(store, 'fe.data.widgetPreviewAutoIdleMs'), gap: num(store, 'fe.data.widgetPreviewAutoGapMs'), dwell: num(store, 'fe.data.widgetPreviewPageDwellMs'),
        settle: num(store, 'fe.data.widgetPreviewAutoSettleMs'), quiet: num(store, 'fe.data.widgetPreviewAutoQuietMs'), perPage: num(store, 'fe.data.widgetPreviewAutoPerPage'),
        perSession: num(store, 'fe.data.widgetPreviewAutoPerSession'), slow: num(store, 'fe.data.widgetPreviewAutoSlowMs'),
        skipEmpty: wp_setting(store, 'fe.ux.widgetPreviewAutoSkipEmpty') !== false }
}
function tick() {
    const store = _store
    if (!store) return
    try {
        if (typeof document !== 'undefined' && document.visibilityState && document.visibilityState !== 'visible') return
        const WS = store.activeWORKSPACE
        const pg = WS && WS.active_page
        // бэк ещё не опрошен — один лёгкий list(meta) активной страницы: команды и переключатель вида появятся по ответу
        if (wpState.supported === null && widgetPreviews_on(store) && pg && !auto.probing) {
            auto.probing = true
            widgetPreviews_load(store, [pg], 'meta').finally(() => { auto.probing = false })
            return
        }
        if (!widgetPreviews_autoOn(store) || !pg) { skip('off'); return }
        const pkey = `${WS.workspace}::${pg}`
        const now = Date.now()
        if (auto.page.key !== pkey) {
            auto.page = { key: pkey, since: now, n: 0, slow: false, metaAt: 0, metaOk: false }
            dropObservers(new Set())
        }
        if (!auto.page.metaOk && now - auto.page.metaAt > 60000) {
            auto.page.metaAt = now
            const want = auto.page.key
            widgetPreviews_load(store, [pg], 'meta').then((r) => { if (auto.page.key === want) auto.page.metaOk = !!r })
        }
        const cfg = autoCfg(store)
        const base = { autoOn: true, visibleTab: true, busy: wpState.busy || !!wpState.pageRun || !!auto.idle, sessionSlow: auto.sessionSlow, perSession: auto.perSession,
            pageSlow: auto.page.slow, perPage: auto.page.n, now, pageSince: auto.page.since, lastInput: auto.lastInput, uiBusy: uiBusy(store), lastAuto: auto.lastAuto,
            metaLoaded: auto.page.metaOk, cfg }
        const g = widgetPreviews_autoEligible({ ...base, w: { known: false, tried: false, ready: true, loadedAt: 1, quietSince: 0, tabOk: true } })
        if (!g.ok && !['no-candidate'].includes(g.why)) { skip(g.why); return }
        const list = (WS.ALL_WIDGETS || []).filter(w => w && String(w.page) === String(pg) && !w.close && !w._softClosed && !w._hiddenOpen)
        const keep = new Set()
        for (const W of list) {
            const slot = widgetPreviews_slotOf(store, W)
            if (!slot) continue
            if (W.loading || W.firstBackendCheck) auto.loadedAt.delete(W.id)
            else if (!auto.loadedAt.has(W.id)) auto.loadedAt.set(W.id, now)
            const known = widgetPreviews_known(slot.key) === true
            if (known || auto.tried.has(slot.key)) { skip(known ? 'has-picture' : 'tried', slot.key); continue }
            const rd = previewReady(W, { allowMax: false })
            const el = rd.ok ? rd.el : previewRoot(W).el
            if (el) keep.add(W.id)
            const tabNow = typeof store.widget_activeTab === 'function' ? (store.widget_activeTab(W) || '') : ''
            if (!auto.firstTab.has(W.id) && rd.ok) auto.firstTab.set(W.id, tabNow)
            const tab0 = W.layoutTab || auto.firstTab.get(W.id) || ''
            const w = {
                known, tried: false, ready: rd.ok, readyWhy: rd.why, loadedAt: auto.loadedAt.get(W.id) || 0, quietSince: el ? quietSince(W, el) : now,
                modified: !!(W.record && W.record._meta && W.record._meta.modified), tabOk: !tab0 || !tabNow || tabNow === tab0,
                scrolled: el ? scrolled(el) : false, maximized: !!(rd.root && rd.root.classList.contains('widget-mobile-max')),
                empty: (rd.ok && cfg.skipEmpty) ? previewIsEmpty(W, rd.el) : false,
            }
            const e = widgetPreviews_autoEligible({ ...base, w })
            if (!e.ok) { skip(e.why, slot.key); if (e.why === 'empty') auto.tried.add(slot.key); continue }
            schedule(store, W, slot)
            break
        }
        dropObservers(keep)
    } catch (e) {
        skip('error')
    }
}
function schedule(store, W, slot) {
    const go = () => {
        auto.idle = 0
        if (!widgetPreviews_autoOn(store) || wpState.busy || wpState.pageRun) { skip('preempted', slot.key); return }
        auto.tried.add(slot.key)
        auto.lastAuto = Date.now()
        auto.page.n++; auto.perSession++
        const pkey = auto.page.key
        widgetPreviews_captureOne(store, W, { mode: 'auto', toast: false }).then((r) => {
            auto.lastAuto = Date.now()
            if (!r) return
            if (r.ok) stats.autoSaves++
            const cfg = autoCfg(store)
            const slow = (r.lt && r.lt > cfg.slow) || (!r.lt && r.ms > 6000)
            if (slow) { auto.sessionSlow++; if (auto.page.key === pkey) auto.page.slow = true; skip('slow', slot.key) }
        })
    }
    try { auto.idle = window.requestIdleCallback ? window.requestIdleCallback(go, { timeout: 1000 }) : setTimeout(go, 50) } catch (e) { auto.idle = setTimeout(go, 50) }
}
const _onInput = () => { auto.lastInput = Date.now() }
const _onMove = () => { const n = Date.now(); if (n - auto.lastMove > 250) { auto.lastMove = n; auto.lastInput = n } }
const _onKey = (e) => { auto.lastInput = Date.now(); if (e && e.key === 'Alt') _altHeld = e.type === 'keydown' }
const _onBlur = () => { _altHeld = false }

// запуск один раз (App.vue mounted): тик раз в 2 с при видимой вкладке, слушатели ввода на window capture, консоль window.widgetPreviews
export function widgetPreviews_start(store) {
    _store = store
    if (auto.started) return
    auto.started = true
    auto.lastInput = Date.now()
    try {
        window.addEventListener('pointerdown', _onInput, true)
        window.addEventListener('wheel', _onInput, { capture: true, passive: true })
        window.addEventListener('touchstart', _onInput, { capture: true, passive: true })
        window.addEventListener('pointermove', _onMove, { capture: true, passive: true })
        window.addEventListener('keydown', _onKey, true)
        window.addEventListener('keyup', _onKey, true)
        window.addEventListener('blur', _onBlur)
    } catch (e) { /* без окна */ }
    auto.timer = setInterval(tick, TICK_MS)
    widgetPreviews_console(store)
}

// ---------------------------------------------------------------- консоль
const fullKey = (k) => { const s = String(k || ''); if (s.startsWith('fe.')) return s; const f = Object.keys(WP_DEFAULTS).find(x => x.endsWith('.' + s)); return f || s }
export function widgetPreviews_console(store) {
    if (typeof window === 'undefined') return
    window.widgetPreviews = {
        get: (k) => k ? wp_setting(store, fullKey(k)) : Object.fromEntries(Object.keys(WP_DEFAULTS).map(x => [x, wp_setting(store, x)])),
        set(k, v) {
            const key = fullKey(k)
            if (!(key in WP_DEFAULTS)) { console.warn('widgetPreviews.set: unknown key', k); return }
            store.setting(key)
            store._settingsOverride[key] = v
            try { localStorage.setItem('feSettings', JSON.stringify(store._settingsOverride)) } catch (e) { /* приватный режим */ }
            store._settingsEpoch++
            return wp_setting(store, key)
        },
        reset() {
            store.setting('fe.ux.widgetPreviews')
            for (const k of Object.keys(WP_DEFAULTS)) delete store._settingsOverride[k]
            try { localStorage.setItem('feSettings', JSON.stringify(store._settingsOverride)) } catch (e) { /* приватный режим */ }
            store._settingsEpoch++
            return this.get()
        },
        stats: () => JSON.parse(JSON.stringify({ ...stats, auto: { perSession: auto.perSession, sessionSlow: auto.sessionSlow, page: auto.page, tried: [...auto.tried], cancelled: auto.cancelled, lastInputAgoMs: Date.now() - auto.lastInput } })),
        state: () => ({ supported: wpState.supported, epoch: wpState.epoch, busy: wpState.busy, pageRun: wpState.pageRun ? { ...wpState.pageRun } : null,
            thumb: [...mem.thumb.keys()], full: [...mem.full.keys()], meta: [...mem.meta.keys()] }),
        pic: (page, widget, inst = '', size = 'full') => { const p = widgetPreviews_pic(page, widget, inst, size); return p ? { ...p, blob: undefined } : null },
        slot: (widgetId) => { const W = (store.activeWORKSPACE?.ALL_WIDGETS || []).find(w => String(w.id) === String(widgetId)); const s = W && widgetPreviews_slotOf(store, W); return s ? { ...s, row: undefined } : null },
        capture: (widgetId, mode = 'manual') => { const W = (store.activeWORKSPACE?.ALL_WIDGETS || []).find(w => String(w.id) === String(widgetId)); return W ? widgetPreviews_captureOne(store, W, { mode }) : Promise.resolve({ ok: false, why: 'no-widget' }) },
        updatePage: () => widgetPreviews_updatePage(store),
        load: (pages, size = 'thumb', force = true) => widgetPreviews_load(store, pages, size, { force }),
        remove: async (page, widget, inst = '') => {
            const r = await _call(store, 'widget_preview_delete', { items: [{ page, widget, inst }] })
            if (r.ok && r.answer && r.answer.deleted) { const k = wpKey(page, widget, inst); memDrop('thumb', k); memDrop('full', k); mem.meta.delete(k); wpState.epoch++ }
            return r.answer || r
        },
        tick: () => tick(),
        ready: (widgetId, allowMax = false) => { const W = (store.activeWORKSPACE?.ALL_WIDGETS || []).find(w => String(w.id) === String(widgetId)); const r = previewReady(W, { allowMax }); return { ok: r.ok, why: r.why } },
        empty: (widgetId) => { const W = (store.activeWORKSPACE?.ALL_WIDGETS || []).find(w => String(w.id) === String(widgetId)); const r = previewReady(W, { allowMax: true }); return r.ok ? previewIsEmpty(W, r.el) : null },
        clearCache: async () => { const db = await _idb(); if (db) await new Promise((res) => { try { const tx = db.transaction(IDB_STORE, 'readwrite'); tx.objectStore(IDB_STORE).clear(); tx.oncomplete = () => res(true); tx.onerror = () => res(false) } catch (e) { res(false) } }); for (const s of ['thumb', 'full']) for (const k of [...mem[s].keys()]) memDrop(s, k); mem.meta.clear(); _lists.clear(); wpState.epoch++; return true },
    }
}

export default { widgetPreviews_start, widgetPreviews_load, widgetPreviews_captureOne, widgetPreviews_updatePage, widgetPreviews_slotOf, widgetPreviews_pic,
    widgetPreviews_picOfRow, widgetPreviews_staleSize, widgetPreviews_chipsText, widgetPreviews_autoEligible, widgetPreviews_on, widgetPreviews_ready, wpState }
